import React, { useState, useEffect } from 'react';
import './Header.css';

// Game header icons
const HeaderIcons = {
    bird: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="24" height="24" fill="#FFD700">
            <path d="M503.2 393.8L280.1 44.25c-10.42-16.33-37.73-16.33-48.15 0L8.807 393.8c-11.11 17.41-11.75 39.42-1.666 57.45C17.07 468.1 35.92 480 56.31 480h399.4c20.39 0 39.24-11.03 49.18-28.77C514.9 433.2 514.3 411.2 503.2 393.8zM256 111.8L327.8 224H256L208 288L177.2 235.3L256 111.8z"/>
        </svg>
    ),
    leaderboard: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" width="20" height="20" fill="currentColor">
            <path d="M572.1 82.38C569.5 71.59 559.8 64 548.7 64h-100.8c.2422-12.45 .1078-23.7-.1559-33.02C447.3 13.63 433.2 0 415.8 0H160.2C142.8 0 128.7 13.63 128.2 30.98C127.1 40.3 127.8 51.55 128.1 64H27.26C16.16 64 6.537 71.59 3.912 82.38C3.1 85.78-15.71 167.2 37.07 245.9c37.44 55.82 100.6 95.03 187.5 117.4c18.7 4.805 31.41 22.06 31.41 41.37C256 428.5 236.5 448 212.6 448H208c-26.51 0-47.99 21.49-47.99 48c0 8.836 7.163 16 15.1 16h223.1c8.836 0 15.1-7.164 15.1-16c0-26.51-21.48-48-47.99-48h-4.644c-23.86 0-43.36-19.5-43.36-43.35c0-19.31 12.71-36.57 31.41-41.37c86.96-22.34 150.1-61.55 187.5-117.4C591.7 167.2 572.9 85.78 572.1 82.38zM77.41 219.8C49.47 178.6 47.01 135.7 48.38 112h80.39c5.359 59.62 20.35 131.1 57.67 189.1C137.4 281.6 100.9 254.4 77.41 219.8zM498.6 219.8c-23.44 34.6-59.94 61.75-109 81.22C426.9 243.1 441.9 171.6 447.2 112h80.39C528.1 135.7 526.5 178.7 498.6 219.8z"/>
        </svg>
    ),
    blog: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" fill="currentColor">
            <path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/>
        </svg>
    ),
    policy: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="18" height="18" fill="currentColor">
            <path d="M256 0v128h128L256 0zM224 128L224 0H48C21.49 0 0 21.49 0 48v416C0 490.5 21.49 512 48 512h288c26.51 0 48-21.49 48-48V160h-127.1C238.3 160 224 145.7 224 128zM272 416h-160C103.2 416 96 408.8 96 400C96 391.2 103.2 384 112 384h160c8.836 0 16 7.162 16 16C288 408.8 280.8 416 272 416zM272 352h-160C103.2 352 96 344.8 96 336C96 327.2 103.2 320 112 320h160c8.836 0 16 7.162 16 16C288 344.8 280.8 352 272 352zM288 272C288 280.8 280.8 288 272 288h-160C103.2 288 96 280.8 96 272C96 263.2 103.2 256 112 256h160C280.8 256 288 263.2 288 272z"/>
        </svg>
    ),
    about: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18" fill="currentColor">
            <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 128c17.67 0 32 14.33 32 32c0 17.67-14.33 32-32 32S224 177.7 224 160C224 142.3 238.3 128 256 128zM296 384h-80C202.8 384 192 373.3 192 360s10.75-24 24-24h16v-64H224c-13.25 0-24-10.75-24-24S210.8 224 224 224h32c13.25 0 24 10.75 24 24v88h16c13.25 0 24 10.75 24 24S309.3 384 296 384z"/>
        </svg>
    ),
    hamburger: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24" height="24" fill="currentColor">
            <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
        </svg>
    ),
    close: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="24" height="24" fill="currentColor">
            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
        </svg>
    )
};

const Header = ({ navigateTo, activePage }) => {
    const [currentActivePage, setCurrentActivePage] = useState(activePage || 'game');
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Update active page based on URL
    useEffect(() => {
        const path = window.location.pathname.toLowerCase();
        if (path.includes('leaderboard')) setCurrentActivePage('leaderboard');
        else if (path.includes('about')) setCurrentActivePage('about');
        else if (path.includes('policy')) setCurrentActivePage('policy');
        else setCurrentActivePage('game');
    }, []);

    // Update when activePage prop changes
    useEffect(() => {
        if (activePage) {
            setCurrentActivePage(activePage);
        }
    }, [activePage]);

    // Close mobile menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMobileMenuOpen && !event.target.closest('.game-header')) {
                setIsMobileMenuOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, [isMobileMenuOpen]);

    // Get page title for breadcrumb
    const getPageTitle = () => {
        switch (currentActivePage) {
            case 'leaderboard': return 'Leaderboard';
            case 'about': return 'About Us';
            case 'policy': return 'Privacy Policy';
            case 'game':
            default: return 'Game';
        }
    };

    const handleNavigation = (page) => {
        navigateTo(page);
        setIsMobileMenuOpen(false);
    };

    return (
        <header className="game-header">
            <div className="nav-container">
                {/* Desktop Navigation */}
                <div className="desktop-nav">
                    <a 
                        href="/" 
                        className="game-logo"
                        onClick={(e) => {
                            e.preventDefault();
                            handleNavigation('game');
                        }}
                    >
                         Flappy Bird
                    </a>
                    <nav className="nav-links">
                        <a 
                            href="/" 
                            className={`nav-link ${currentActivePage === 'game' ? 'active' : ''}`} 
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('game');
                            }}
                        >
                            Game
                        </a>
                        <a 
                            href="/leaderboard" 
                            className={`nav-link ${currentActivePage === 'leaderboard' ? 'active' : ''}`} 
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('leaderboard');
                            }}
                        >
                            {HeaderIcons.leaderboard} Leaderboard
                        </a>
                        <a 
                            href="https://blog.flappybird.tv" 
                            className="nav-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {HeaderIcons.blog} Blog
                        </a>
                        <a 
                            href="/policy" 
                            className={`nav-link ${currentActivePage === 'policy' ? 'active' : ''}`} 
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('policy');
                            }}
                        >
                            {HeaderIcons.policy} Privacy Policy
                        </a>
                        <a 
                            href="/about" 
                            className={`nav-link ${currentActivePage === 'about' ? 'active' : ''}`} 
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('about');
                            }}
                        >
                            {HeaderIcons.about} About Us
                        </a>
                    </nav>
                </div>

                {/* Mobile Navigation */}
                <div className="mobile-nav">
                    <div className="mobile-breadcrumb">
                        <a 
                            href="/" 
                            className="breadcrumb-home"
                            onClick={(e) => {
                                e.preventDefault();
                                handleNavigation('game');
                            }}
                        >
                            Flappy Bird
                        </a>
                        {currentActivePage !== 'game' && (
                            <>
                                <span className="breadcrumb-separator"> / </span>
                                <span className="breadcrumb-current">{getPageTitle()}</span>
                            </>
                        )}
                    </div>
                    <button 
                        className="hamburger-menu"
                        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                        aria-label="Toggle menu"
                    >
                        {isMobileMenuOpen ? HeaderIcons.close : HeaderIcons.hamburger}
                    </button>
                </div>

                {/* Mobile Menu Overlay */}
                {isMobileMenuOpen && (
                    <div className="mobile-menu-overlay">
                        <nav className="mobile-menu-links">
                            <a 
                                href="/" 
                                className={`mobile-nav-link ${currentActivePage === 'game' ? 'active' : ''}`} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('game');
                                }}
                            >
                                Game
                            </a>
                            <a 
                                href="/leaderboard" 
                                className={`mobile-nav-link ${currentActivePage === 'leaderboard' ? 'active' : ''}`} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('leaderboard');
                                }}
                            >
                                {HeaderIcons.leaderboard} Leaderboard
                            </a>
                            <a 
                                href="https://blog.flappybird.tv" 
                                className="mobile-nav-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                {HeaderIcons.blog} Blog
                            </a>
                            <a 
                                href="/policy" 
                                className={`mobile-nav-link ${currentActivePage === 'policy' ? 'active' : ''}`} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('policy');
                                }}
                            >
                                {HeaderIcons.policy} Privacy Policy
                            </a>
                            <a 
                                href="/about" 
                                className={`mobile-nav-link ${currentActivePage === 'about' ? 'active' : ''}`} 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleNavigation('about');
                                }}
                            >
                                {HeaderIcons.about} About Us
                            </a>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
};

export default Header; 